<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row class="mb-5">
        <v-col>
          <h3><v-icon class="mr-2">mdi-email-alert</v-icon> Configuração de SLAS</h3>
        </v-col>
      </v-row>
      <v-divider class="my-3"></v-divider>
      <v-row>
        <v-col align="right">
          <TheButton text="Adicionar Mensagem" icon="mdi-plus" @click="addDialog()" />
        </v-col>
      </v-row>
      <v-divider class="my-5"></v-divider>
      <v-data-table dense :headers="headers" :items="data">
        <template v-slot:[`item.active`]="{ item }">
          <v-btn icon tile @click="active(item)" color="green" v-if="item.active">
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn icon tile @click="active(item)" color="red" v-if="!item.active">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.repeat`]="{ item }">
          <v-btn icon tile @click="repeat(item)" color="green" v-if="item.repeat">
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn icon tile @click="repeat(item)" color="red" v-if="!item.repeat">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn icon tile @click="editGroupDialog(item.id)">
            <v-icon>mdi-account-lock</v-icon>
          </v-btn>
          <v-btn icon tile @click="editDialog(item)">
            <v-icon>mdi-pen</v-icon>
          </v-btn>
          <v-btn icon tile @click="remove(item.id)">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <TheDialog title="Mensagens" v-model="dialog" icon="mdi-message-bulleted" width="80%">
      <template>
        <v-row>
          <v-col><TheInput label="Título" v-model="sla.rule"/></v-col>
        </v-row>
        <v-row>
          <v-col><vue-editor v-model="sla.text"/></v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col>
            <v-select
              outlined
              dense
              hide-details
              :items="actions"
              item-value="value"
              item-text="text"
              label="Ação"
              v-model="sla.action"
            ></v-select>
          </v-col>
          <v-col cols="1">
            <TheInput label="Status 1" v-model="sla.status1" />
          </v-col>
          <v-col cols="1">
            <TheInput label="Status 2" v-model="sla.status2" :disabled="sla.action > 1" />
          </v-col>
          <v-col>
            <v-select
              outlined
              dense
              hide-details
              :items="time"
              item-text="text"
              item-value="value"
              label="Quando"
              v-model="sla.time"
            ></v-select>
          </v-col>
          <v-col>
            <v-checkbox label="Repetir?" v-model="sla.repeat"></v-checkbox>
          </v-col>
        </v-row>
      </template>
      <template v-slot:actions>
        <TheButton text="Salvar" icon="mdi-content-save" @click="saveForm()" color="green" />
      </template>
    </TheDialog>

    <TheDialog title="Grupos" v-model="dialogGroups" icon="mdi-account-lock" width="480px">
      <template>
        <v-select
          :items="groups"
          v-model="groupsSelect"
          item-value="idGrp"
          item-text="descGrp"
          multiple
          outlined
          dense
          hide-details
        ></v-select>
      </template>
      <template v-slot:actions>
        <TheButton text="Salvar" icon="mdi-content-save" @click="saveGroups()" color="green" />
      </template>
    </TheDialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { VueEditor } from 'vue2-editor'
import TheButton from '@/components/TheButton'
import TheInput from '@/components/TheInput'
import TheDialog from '@/components/TheDialog'

export default {
  name: 'SlaMessages',
  components: {
    TheInput,
    TheButton,
    TheDialog,
    VueEditor,
  },
  data: () => ({
    sla: {},
    headers: [
      { text: 'ID', value: 'id', width: '10%' },
      { text: 'Regra', value: 'rule' },
      { text: 'Ativo', value: 'active', width: '10%' },
      { text: 'Repetir?', value: 'repeat', width: '10%' },
      { text: 'Ações', value: 'action', width: '15%', align: 'center' },
    ],
    data: [],
    dialog: false,
    dialogGroups: false,
    actions: [
      { text: 'Mudança de Status de Pedido', value: 1 },
      { text: 'Tempo em Status', value: 2 },
    ],
    time: [
      { text: 'Instântaneo', value: '0' },
      { text: '2h', value: '1' },
      { text: '4h', value: '2' },
      { text: '6h', value: '3' },
      { text: '8h', value: '4' },
      { text: '1d', value: '5' },
      { text: '2d', value: '6' },
      { text: '3d', value: '7' },
      { text: '4d', value: '8' },
    ],
    controller: false,
    id: null,
    groups: [],
    groupsHeader: [
      { text: 'Grupo', value: 'descGrp' },
      { text: 'Ações', value: 'action' },
    ],
    groupsSelect: [],
    groupId: false,
  }),
  methods: {
    addDialog() {
      this.controller = true
      this.sla = {}
      this.dialog = true
    },
    editDialog(item) {
      this.sla = item
      this.id = item.id
      this.controller = false
      this.dialog = true
    },
    editGroupDialog(id) {
      this.groupId = id
      this.loadSlaGroups(id)
    },
    loadData() {
      axios
        .get(`${baseApiUrl}/sla`)
        .then((res) => {
          this.data = res.data
          this.loadGroups()
        })
        .catch(showError)
    },
    loadGroups() {
      const url = `${baseApiUrl}/grp`
      axios
        .get(url)
        .then((res) => {
          this.groups = res.data
        })
        .catch(showError)
    },
    loadSlaGroups(id) {
      axios
        .get(`${baseApiUrl}/sla/${id}/groups`)
        .then((res) => {
          this.groupsSelect = res.data
          this.dialogGroups = true
        })
        .catch(showError)
    },
    saveForm() {
      if (this.controller) {
        this.save()
      } else {
        const item = this.sla
        const id = this.id
        this.edit(id, item)
      }
      this.dialog = false
    },
    save() {
      const sla = this.sla
      axios
        .post(`${baseApiUrl}/sla`, sla)
        .then(() => {
          this.loadData()
        })
        .catch(showError)
    },
    saveGroups() {
      const id = this.groupId
      const sla = this.groupsSelect
      axios
        .post(`${baseApiUrl}/sla/${id}/groups`, sla)
        .then(() => {
          this.loadData()
          this.dialogGroups = false
        })
        .catch(showError)
    },
    edit(id, item) {
      axios
        .put(`${baseApiUrl}/sla/${id}`, item)
        .then(() => {
          this.loadData()
        })
        .catch(showError)
    },
    remove(id) {
      axios
        .delete(`${baseApiUrl}/sla/${id}`)
        .then(() => {
          this.loadData()
        })
        .catch(showError)
    },
    active(item) {
      const sla = {
        active: !item.active,
      }
      this.edit(item.id, sla)
    },
    repeat(item) {
      const sla = {
        repeat: !item.repeat,
      }
      this.edit(item.id, sla)
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style></style>
